"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _css = require("@emotion/css");
var _progressTracker = _interopRequireDefault(require("@amzn/meridian-tokens/component/progress-tracker"));
var _progressTrackerContext = _interopRequireDefault(require("./progress-tracker-context"));
var _theme = require("../theme");
var _listReset = _interopRequireDefault(require("./../_styles/list-reset"));
var _token = require("./../_utils/token");
var _rtl = require("./../_utils/rtl");
var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var direction = _ref.direction,
    autoTrackLength = _ref.autoTrackLength;
  var isRow = direction === "row";
  return (0, _css.css)(_listReset["default"], _objectSpread(_objectSpread({}, t.typographyCss("textDefault")), {}, {
    color: t("textDefaultForegroundColor"),
    display: "flex",
    flexDirection: direction,
    alignItems: "stretch",
    // only center the Progress tracker in it's parent container if direction is row and autoTrackLength={true}
    justifyContent: autoTrackLength && isRow && "center"
  }));
}, ["direction", "autoTrackLength"]);
var ProgressTracker = function ProgressTracker(props) {
  var compact = props.compact,
    type = props.type,
    autoTrackLength = props.autoTrackLength,
    direction = props.direction;
  var steps = _react["default"].Children.toArray(props.children);
  var t = (0, _theme.useTheme)(_progressTracker["default"], "progressTracker");
  var rowLabelAlignment = (0, _rtl.getHorizontalDirection)(props.rowLabelAlignment);
  var neutral = type === "neutral";
  var size = compact ? "small" : "large";
  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);

  // Set a width percentage fwor the progress tracker steps in a progress
  // tracker with direction="row" and autoTrackLength={true}
  var autoStepWidthPercentage = "".concat(Math.floor(1 / steps.length * 100), "%");
  return /*#__PURE__*/_react["default"].createElement("ol", (0, _extends2["default"])({}, passThroughProps, {
    className: styles(t, {
      direction: direction,
      autoTrackLength: autoTrackLength
    })
  }), steps.map(function (step, index) {
    return /*#__PURE__*/_react["default"].createElement(_progressTrackerContext["default"].Provider, {
      key: step.props.id || index,
      value: {
        previousStepType: (steps[index - 1] || {
          props: {}
        }).props.type,
        nextStepType: (steps[index + 1] || {
          props: {}
        }).props.type,
        direction: direction,
        autoTrackLength: autoTrackLength,
        rowLabelAlignment: rowLabelAlignment,
        size: size,
        neutral: neutral,
        labelPast: props.labelPast,
        labelPresent: props.labelPresent,
        labelFuture: props.labelFuture,
        autoStepWidthPercentage: autoStepWidthPercentage,
        t: t
      }
    }, step);
  }));
};
ProgressTracker.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   */
  "aria-*": _propTypes["default"].string,
  /**
   * Set this to true to have the tracks automatically adjust their length.
   *
   * For columns the track will fit the content of the step, for rows the tracks will evenly fill the available width.
   */
  autoTrackLength: _propTypes["default"].bool,
  /**
   * A list of steps to add to the progress tracker.
   *
   * Note that ProgressTracker expects a `type` prop on each of its direct
   * children. This means that if you wrap `ProgresTrackerStep` in your own
   * custom component (e.g. `MyCustomStep`) you still have to set the `type`
   * prop at the top level and then pass it down:
   *
   * ```
   * // CORRECT
   * const MyCustomStep = ({ type }) =>
   *   <ProgressTrackerStep
   *     type={type}
   *     label="I'll render just fine"
   *   />
   *
   * <ProgressTracker>
   *   <MyCustomStep type="past" />
   * </ProgressTracker>
   * ```
   *
   * Setting the `type` anywhere other than on a direct child of
   * `ProgressTracker` will not work correctly:
   *
   * ```
   * // INCORRECT
   * const MyCustomStep = () =>
   *   <ProgressTrackerStep
   *     type="past"
   *     label="I won't render correctly"
   *   />
   *
   * <ProgressTracker>
   *   <MyCustomStep />
   * </ProgressTracker>
   * ```
   *
   * Another important thing to note: `ProgressTracker` does not allow steps
   * to be wrapped in custom markup. You cannot do something like this:
   *
   * ```
   * // INCORRECT
   * <ProgressTracker>
   *   <div><ProgressTrackerStep /></div>
   * </ProgressTracker>
   * ```
   */
  children: _propTypes["default"].node,
  /**
   * Set this to true to display a compact (small) progress tracker. Note that
   * labels and icons will not not be shown for compact progress trackers.
   */
  compact: _propTypes["default"].bool,
  /**
   * All props starting with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   */
  "data-*": _propTypes["default"].string,
  /**
   * Whether to display the progress tracker in a vertical "column" format or a
   * horizontal "row" format.
   */
  direction: _propTypes["default"].oneOf(["column", "row"]),
  /**
   * A label that screen readers will read for all steps with type="future".
   */
  labelFuture: _propTypes["default"].string,
  /**
   * A label that screen readers will read for all steps with type="past".
   */
  labelPast: _propTypes["default"].string,
  /**
   * A label that screen readers will read for all steps with type="present".
   */
  labelPresent: _propTypes["default"].string,
  /**
   * Determines the alignment of the progress tracker's labels when `direction`
   * is set to "row". Center alignment centers the labels below the milestone,
   * start alignment aligns the labels below the left side of the milestone in
   * left-to-right layouts and on the right side of the milestone in
   * right-to-left layouts.
   */
  rowLabelAlignment: _propTypes["default"].oneOf(["center", "start"]),
  /**
   * If set to "theme" the progress tracker will be highlighted with the current
   * theme's accent color. If set to "neutral" the progress tracker will be
   * shown using neutral grays.
   */
  type: _propTypes["default"].oneOf(["theme", "neutral"])
} : {};
ProgressTracker.defaultProps = {
  rowLabelAlignment: "center",
  direction: "column",
  type: "theme",
  labelPast: "Past",
  labelPresent: "Present",
  labelFuture: "Future",
  autoTrackLength: false
};
var _default = ProgressTracker;
exports["default"] = _default;